import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext/authContext';
import IntroPage from './components/IntroPage/IntroPage';
import MissionVision from './components/IntroPage/MissionVision';
import MeetTheTeam from './components/IntroPage/MeetTheTeam';
import Login from './components/Login/login_temp';
import VideoHub from './components/VideoHub/VideoHub';
import HomeworkSubmission from './components/HomeworkSubmission/HomeworkSubmission';
import HomeworkRetrieval from './components/HomeworkRetrieval/HomeworkRetrieval';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import Layout from './components/Layout/Layout';
import ZoomLink from './components/ZoomLink/ZoomLink';
import QuizTime from './components/QuizTime/QuizTime';
import './App.css';

const ProtectedPage = ({ children }) => {
  return <Layout>{children}</Layout>;
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<IntroPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/mission-vision" element={<MissionVision />} />
          <Route path="/meet-the-team" element={<MeetTheTeam />} />

          {/* Protected pages */}
          <Route element={<PrivateRoute roles={['admin', 'warden', 'tutor']} />}>
            <Route
              path="/video-hub"
              element={
                <ProtectedPage>
                  <VideoHub />
                </ProtectedPage>
              }
            />
            <Route
              path="/homework-submission"
              element={
                <ProtectedPage>
                  <HomeworkSubmission />
                </ProtectedPage>
              }
            />
            <Route
              path="/homework-retrieval"
              element={
                <ProtectedPage>
                  <HomeworkRetrieval />
                </ProtectedPage>
              }
            />
            <Route
              path="/zoom-link"
              element={
                <ProtectedPage>
                  <ZoomLink />
                </ProtectedPage>
              }
            />
            <Route
              path="/quiz-time"
              element={
                <ProtectedPage>
                  <QuizTime />
                </ProtectedPage>
              }
            />
          </Route>

          {/* Anything unknown goes back to the homepage */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;